import { client, formatQueryParams } from 'util/sdk';

export default ({ fspId, id, ...params }) =>
  client
    .fsps(fspId)
    .payeeAuditLogs.query(formatQueryParams({ payeeId: id, ...params }));
